import type { UseCollectionQueryKeyParams, CollectionQueryKey } from './types';

export const getCollectionListKey = (
  params: UseCollectionQueryKeyParams,
): CollectionQueryKey => ['users', 'collections', params];
